// PWA utilities for service worker registration and install prompt

// Register service worker
export const registerServiceWorker = async () => {
  if ('serviceWorker' in navigator) {
    try {
      const registration = await navigator.serviceWorker.register('/sw.js');
      console.log('Service Worker registered:', registration);

      // Handle updates
      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing;
        if (newWorker) {
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              // New content is available, notify user
              showUpdateNotification();
            }
          });
        }
      });
    } catch (error) {
      console.error('Service Worker registration failed:', error);
    }
  }
};

// Handle PWA install prompt
let deferredPrompt: any = null;

export const setupInstallPrompt = () => {
  window.addEventListener('beforeinstallprompt', (e) => {
    // Prevent the mini-infobar from appearing on mobile
    e.preventDefault();
    // Stash the event so it can be triggered later
    deferredPrompt = e;

    // Show custom install button or notification
    showInstallPrompt();
  });

  window.addEventListener('appinstalled', () => {
    // App was installed
    console.log('PWA was installed');
    deferredPrompt = null;
  });
};

export const promptInstall = async () => {
  if (!deferredPrompt) return false;

  // Show the install prompt
  deferredPrompt.prompt();

  // Wait for the user to respond to the prompt
  const { outcome } = await deferredPrompt.userChoice;

  // Reset the deferred prompt
  deferredPrompt = null;

  return outcome === 'accepted';
};

// Show update notification
const showUpdateNotification = () => {
  // You can implement a toast notification here
  console.log('New version available! Please refresh to update.');
  // For now, just reload automatically
  if (confirm('A new version is available. Reload to update?')) {
    window.location.reload();
  }
};

// Show install prompt
const showInstallPrompt = () => {
  // You can implement a custom install UI here
  console.log('App can be installed! Show install button.');
  // For example, show a toast or update a button's visibility
};

// Check if app is installed
export const isPWAInstalled = () => {
  return window.matchMedia('(display-mode: standalone)').matches ||
         (window.navigator as any).standalone === true;
};

// Get PWA display mode
export const getPWADisplayMode = () => {
  if (window.matchMedia('(display-mode: standalone)').matches) {
    return 'standalone';
  }
  if (window.matchMedia('(display-mode: minimal-ui)').matches) {
    return 'minimal-ui';
  }
  if (window.matchMedia('(display-mode: browser)').matches) {
    return 'browser';
  }
  return 'unknown';
};
